import { SVGProps } from 'react'

export const MP4Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 4C4 1.79086 5.79086 0 8 0H24L36 12V36C36 38.2091 34.2091 40 32 40H8C5.79086 40 4 38.2091 4 36V4Z"
      fill="#155EEF"
    />
    <path
      opacity="0.3"
      d="M24 0L36 12H28C25.7909 12 24 10.2091 24 8V0Z"
      fill="white"
    />
    <path
      d="M10.4878 25.4545H12.1945L13.9971 29.8523H14.0738L15.8763 25.4545H17.583V32H16.2407V27.7397H16.1863L14.4925 31.968H13.5784L11.8845 27.7237H11.8302V32H10.4878V25.4545ZM18.7232 32V25.4545H21.3056C21.802 25.4545 22.225 25.5494 22.5744 25.739C22.9238 25.9265 23.1902 26.1875 23.3734 26.522C23.5588 26.8544 23.6515 27.2379 23.6515 27.6726C23.6515 28.1072 23.5577 28.4908 23.3702 28.8232C23.1827 29.1555 22.911 29.4144 22.5552 29.5998C22.2015 29.7852 21.7733 29.8778 21.2704 29.8778H19.6245V28.7688H21.0467C21.313 28.7688 21.5325 28.723 21.7051 28.6314C21.8798 28.5376 22.0098 28.4087 22.095 28.2447C22.1824 28.0785 22.226 27.8878 22.226 27.6726C22.226 27.4553 22.1824 27.2656 22.095 27.1037C22.0098 26.9396 21.8798 26.8129 21.7051 26.7234C21.5304 26.6317 21.3088 26.5859 21.0403 26.5859H20.1071V32H18.7232ZM24.4129 30.8494V29.7596L27.1455 25.4545H28.0851V26.9631H27.529L25.8064 29.6893V29.7404H29.6895V30.8494H24.4129ZM27.5546 32V30.517L27.5802 30.0344V25.4545H28.8778V32H27.5546Z"
      fill="white"
    />
  </svg>
)
